import type { AgentId, AgentStatus } from '@shared/types';

/** The living orb. size: 'xs' (chip) | 'md' (grid) | '' (hero 110px). */
export function Orb({
  agent,
  size = 'md',
  state = 'idle',
}: {
  agent: AgentId;
  size?: 'xs' | 'md' | '';
  state?: AgentStatus | 'idle';
}) {
  return (
    <span className={`orb ${agent} ${size}`.trim()} data-state={state} aria-label={`${agent} orb`}>
      <i />
      <i />
      <i />
      <span className="badge" />
    </span>
  );
}
